import {
  Component,
  ElementRef,
  Input,
  NgModule,
  Renderer2,
} from '@angular/core';
import { FFacetInfoModule } from '@wipo/w-angular/internal';
import { WInputTextBase } from '@wipo/w-angular/shared';

import { CommonModule } from '@angular/common';
import { CreateControlAccessProvider } from '@wipo/w-angular/shared';
import { FormsModule } from '@angular/forms';
import { WButtonModule } from '@wipo/w-angular/w-button';
import { WHideEmptyModule } from '@wipo/w-angular/directives';

@Component({
    selector: 'w-input-text',
    templateUrl: './w-input-text.component.html',
    styles: [
        `
      .b-input__label--not-floating {
        padding-bottom: 0;
      }
    `,
    ],
    providers: [CreateControlAccessProvider(WInputTextComponent)],
    host: {
        '[class.b-input--is-read-only]': 'isReadOnly',
        '[class.b-input--is-empty]': '!value',
    },
    standalone: false
})
/*
@id w-input-text
@name w-input-text
@status release
*/
export class WInputTextComponent extends WInputTextBase {
  @Input() prefix: string = ''; // text displayed before input text
  @Input() suffix: string = ''; // text displayed after input text
  @Input() labelCapsLockOn = 'CAPS LOCK ON'; // text shown when caps lock enabled (applies for password)
  @Input() isReadOnly: boolean = false; // acts as OutputText component (disabled, but text not grayed out)

  override get isDisabled(): boolean {
    return this.disabled || this.isReadOnly;
  }
  get isPassword() {
    return this.type === 'password' || this.togglePassword;
  }
  togglePassword = false;

  get capsLockLabel(): string {
    // show only for password field
    if (this.capsLockOn && this.type === 'password') {
      return this.labelCapsLockOn;
    } else {
      return '';
    }
  }
  // tslint:disable-next-line: variable-name
  constructor(
    protected _renderer: Renderer2,
    protected _elementRef: ElementRef
  ) {
    super();
  }
  togglePwd() {
    if (this.isPassword) {
      this.togglePassword = this.type === 'password';
      this.type = this.togglePassword ? 'text' : 'password';
    }
  }
  override hasContent(): boolean {
    return super.hasContent() || !!this.prefix || !!this.suffix;
  }
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WButtonModule,
    WHideEmptyModule,
    FFacetInfoModule,
  ],
  exports: [WInputTextComponent],
  declarations: [WInputTextComponent],
})
export class WInputTextModule { }
